<template>
  <v-container fluid>
     <v-layout justify-center row align-content-space-around>
       <v-flex lg7 md7 sm8 xs12>

        <div id="termsContainer">

          <div id="termsHeader">
            <div class="mb-4">
            <h3 class="mb-2">Terms of Service</h3>
            <hr class="thick mb-2" />
            </div>
            <div class="intro-guide mt-2" v-if="!acknowledged">
              <p>Welcome to Amaze. Before you begin, please review and accept our terms of service, then we’ll take you to your personal profile where you can tell us more about yourself.</p>
              <div class="spacer"></div>
            </div>
          </div>

          <div id="termsWrapper" class="mb-4 mt-2" >
            <p>This website is administered by staff at RTI International.</p>

                <p>RTI makes information available on this Site, subject to the following Terms of Use ("Terms"). By accessing this Site, you agree to these Terms. If you do not agree to all of these Terms, do not use this Site. RTI reserves the right to change these Terms at any time without notice. These Terms represent the entire understanding between you and RTI relating to the use of this Site.</p>

                <h3>Security Notice</h3>

                <p>For SITE SECURITY purposes and to ensure that this service remains available to all users, RTI uses software programs to monitor network traffic to identify unauthorized attempts to upload or change information, or otherwise cause damage.</p>

                <p>Unauthorized attempts to upload information or change information on this service are strictly prohibited and may be punishable under the Computer Fraud and Abuse Act of 1986 and the National Information Infrastructure Protection Act.</p>

                <h3>Warranties and Disclaimers</h3>

                <p>ALL MATERIALS ON THIS SITE ARE PROVIDED "AS IS" WITHOUT WARRANTY OF ANY KIND, EXPRESSED OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.</p>

                <p>RTI shall have the right, but not the responsibility, to remove content that may be in violation of this agreement, any rules posted here, or any applicable provisions of law. RTI may change any information on this Site or any product or service described on this Site, including functionality or performance thereof, any time without notice.</p>

                <h3>Disclaimer of Endorsement</h3>

                <p>The documents posted on this Site may contain hypertext links or pointers to information created and maintained by other public and private organizations. These links and pointers are provided for visitors' convenience. We do not control or guarantee the accuracy, relevance, timeliness, or completeness of any linked information. Further, the inclusion of links or pointers to websites other than an RTI-managed website is not intended to assign importance to those sites and the information contained therein, nor is it intended to endorse, recommend, or favor any views expressed, or commercial products or services offered on these outside sites, or the organizations sponsoring the sites, by trade name, trademark, manufacture, or otherwise.</p>

                <p>Reference in this Site to any specific commercial products, processes, or services, or the use of any trade, firm or corporation name is for the information and convenience of Site visitors, and does not constitute endorsement, recommendation, or favoring by RTI.</p>

                <h3>Links to Other Websites</h3>

                <p>This Site contains links to other websites that are not hosted by RTI. These websites are not under the control of RTI. RTI is not responsible for their content or the content of any information linked to these websites. Links to other websites are provided as a convenience to our users and do not imply any endorsement by RTI of information contained in these websites or the organizations that support them.</p>

                <h3>Disclaimer of Liability</h3>

                <p>IN NO EVENT WILL RTI BE LIABLE FOR ANY DAMAGE WHATSOEVER (INCLUDING WITHOUT LIMITATION DAMAGES RELATING TO LOST REVENUES OR PROFITS, LOST DATA, WORK STOPPAGE, COMPUTER FAILURE OR MALFUNCTION) RESULTING FROM OR IN ANY WAY RELATED TO THE USE OF ANY MATERIALS POSTED ON OR MADE AVAILABLE AT THIS SITE OR ANY OTHER SITE TO WHICH A LINK IS PROVIDED OR ON WHICH A LINK IS PROVIDED TO THIS SITE, REGARDLESS OF THE LEGAL THEORY ON WHICH SUCH DAMAGES ARE BASED.</p>

                <p>With respect to the content of this Site, neither RTI, nor its employees and contractors make any warranty, expressed or implied or statutory, including but not limited to the warranties of non-infringement of third party rights, title, and the warranties of merchantability and fitness for a particular purpose with respect to content available from this Site or other Internet resources linked from it.</p>

                <p>Additionally, RTI does not assume any legal liability for the accuracy, completeness, or usefulness of any information, product, or process disclosed herein nor freedom from computer virus, and do not represent that use of such information, product, or process would not infringe on privately owned rights.</p>

                <h3>Copyright Notice</h3>

                <p>Except for content with respect to which a third-party copyright is noted, and content contributed by users, with respect to which users grant a license to RTI elsewhere in these Terms and Conditions, this website and its content are copyright of Research Triangle Institute. All Rights Reserved.</p>

                <p>Any redistribution or reproduction of part or all of the contents in any form is prohibited other than the following:</p>

                <ul><li>You may print or download to a local hard disk extracts for your personal and non-commercial use only.</li>
                  <li>You may copy the content to individual third parties for their personal use, but only if you acknowledge the website as the source of the material.</li>
                  <li>You may share links to content.</li>
                </ul><p>You may not, except with our express written permission, distribute or commercially exploit the content. Nor may you transmit it or store it in any other website or other form of electronic retrieval system.</p>

                <p>If a copyright is indicated on a photo, graphic, or any other material, permission to copy these materials must be obtained from the original source.</p>

                <h3>Computer Fraud and Abuse Act</h3>

                <p>Unauthorized attempts to upload information and/or change information on this Site are strictly prohibited and are subject to prosecution under Title 18 U.S.C., Sections1001 and 1030).</p>

                <h3>Registering with and Commenting on this Site</h3>

                <p>Visitors may subscribe to a feed of content from this Site and may comment on Site content and otherwise post content. To do so, visitors may need to provide personal information. For information on how we protect any personal information you provide to us, see our&nbsp;<a href="/privacy-policy">Privacy Policy</a>.</p>

                <p>Visitors are prohibited from using the Site to advertise, perform, or promote any commercial solicitation of goods and/or services.</p>

                <p>By commenting or posting on the Site, visitors grant RTI a non-exclusive, royalty-free license to use, publish, broadcast and reproduce their comments without limitation in any and all media, worldwide, in perpetuity, for any purpose whatsoever. This includes, without limitation, the right to create derivative works of, and to use, the content posted on the Site to develop, enhance, distribute, and market RTI products and services.</p>

                <p>By commenting or posting on the Site, visitors represent and warrant that all content posted is their original work in which they own the copyright, or have been granted permission to use and in no way violates or infringes on the copyright, registered trademark, right of publicity, patent, or intellectual property rights of a third party. Visitors also represent and warrant that no content that they post is obscene, fraudulent, threatening, harassing, defamatory, libelous, invasive of another's privacy, or otherwise unlawful.</p>

                <h3>Site Management</h3>

                <p>RTI manages its own content and the design and organization of this Site and has the right but not the responsibility to remove content that might be in violation of these Terms, any rules posted here, or any applicable provisions of law.</p>

          </div>

          <div v-if="!acknowledged" id="termsAccept">
            <button class="elevation-3 v-btn theme--dark primary" v-on:click="accept">Accept</button>
          </div>
          <div v-else id="termsAccept">
            <router-link to="/dashboard">Go to Dashboard</router-link>
          </div>

        </div>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
  @import "src/styles/variables.scss";

  #termsContainer {
    text-align: left;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    vertical-align: top;
    height: calc(100vh - 350px);
    min-height: 400px;
    margin-top: -30px;
  }
  #termsAccept {
    position: relative;
    bottom: 0;
  }
  #termsWrapper {
    border: 1px solid $stroke;
    overflow: scroll;
    flex: 1 1 auto;
    padding: 1em;

    h3 {
      font: Bold 16px/24px $amaze-text-font-stack;
    }
  }
  #termsAccept button {
    margin-left: 0px;
    flex: 0;
  }
  .intro-guide {
    font: Bold 16px/24px $amaze-text-font-stack;

  }

  body {
    //overflow: hidden;
  }

</style>

<script>
import AmazeNotifications from "@/components/Widgets/AmazeNotifications";

export default {
  components: {
    AmazeNotifications
  },
  computed: {
    acknowledged() {
      return this.$auth.user().tos_ack;
    }
  },
  methods: {
    accept() {
      this.$http.post("users/terms").then(
        response => {
          this.$auth.fetch({ success: function() {
            this.$router.push({ path: "/profile/edit" });
          } })
        },
        response => {
          console.log("Error accepting terms of service.");
          this.$store.commit("updateMessage", {
            message: "We've encountered an error and are unable to continue at this time.",
            snackbar: true
          });
        }
      );
    }
  }
};
</script>
